export default __webpack_public_path__ + "static/file-sharing-mobile-69ff1de4cb016e1d672a987845bdb04a.png";